const timeFmt = new Intl.DateTimeFormat("tr-TR", { hour: "2-digit", minute: "2-digit" });
const dayFmt = new Intl.DateTimeFormat("tr-TR", { day: "numeric", month: "long", year: "numeric" });
const fullFmt = new Intl.DateTimeFormat("tr-TR", { dateStyle: "full", timeStyle: "short" });
const shortFmt = new Intl.DateTimeFormat("tr-TR", { day: "numeric", month: "short", year: "numeric" });

export const fmtTime = (iso: string): string => timeFmt.format(new Date(iso));
export const fmtDay = (iso: string): string => dayFmt.format(new Date(iso));
export const fmtFull = (iso: string): string => fullFmt.format(new Date(iso));
export const fmtDate = (iso: string): string => shortFmt.format(new Date(iso));

export function fmtBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toLocaleString("tr-TR", { maximumFractionDigits: 1 })} KB`;
  return `${(n / 1024 / 1024).toLocaleString("tr-TR", { maximumFractionDigits: 1 })} MB`;
}

/** Hesap yaşı: "3 yıl", "5 ay", "12 gün". */
export function fmtAge(iso: string, now = Date.now()): string {
  const days = Math.max(0, Math.floor((now - new Date(iso).getTime()) / 86_400_000));
  if (days >= 365) return `${Math.floor(days / 365)} yıl`;
  if (days >= 30) return `${Math.floor(days / 30)} ay`;
  return `${days} gün`;
}

/** Davet kalan süresi (sn → "6 sa"). */
export function fmtRemaining(expiresAt: string | null, now = Date.now()): string {
  if (!expiresAt) return "∞";
  const s = Math.max(0, Math.floor((new Date(expiresAt).getTime() - now) / 1000));
  if (s >= 86_400) return `${Math.floor(s / 86_400)} gün`;
  if (s >= 3600) return `${Math.floor(s / 3600)} sa`;
  return `${Math.max(1, Math.floor(s / 60))} dk`;
}

/** Göreli zaman (aktif oturumlar): az önce / 5 dk önce / 3 sa önce / 2 gün önce. */
export function fmtAgo(iso: string, now = Date.now()): { key: "justNow" | "minutes" | "hours" | "days"; n: number } {
  const s = Math.max(0, Math.floor((now - new Date(iso).getTime()) / 1000));
  if (s < 60) return { key: "justNow", n: 0 };
  if (s < 3600) return { key: "minutes", n: Math.floor(s / 60) };
  if (s < 86_400) return { key: "hours", n: Math.floor(s / 3600) };
  return { key: "days", n: Math.floor(s / 86_400) };
}
